<template>
  <div class="info_cheart_ct">
    <el-card style="height:100%">
      <p>企业数量就业人数分行业门类分析</p>
      <div ref="ehachrValue" class="ehcartds" style="height:90%"></div>
    </el-card>
  </div>
</template>

<script>
import { infoDataSetGir } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.handEcharts();
  },
  methods: {
    async getSetGir() {},
    handEcharts(dataInfo) {
      let echarts = this.$echarts.init(this.$refs.ehachrValue);
      let option = {
        title: {
          // text: "一天用电量分布",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["企业占比", "就业人数占比"],
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: true },
            axisLabel: {
              interval: 0,
              rotate: 40, //角度顺时针计算的
            },
            data: [
              "A.农、林、牧、渔业",
              "B采矿业",
              "C制造业",
              "D.电力、热力、燃气及水生产和供应业",
              "E.建筑业",
              "F批发和零售业",
              "G.交通运输、仓储和邮政业",
            ],
          },
        ],
        grid: {
          bottom: 160,
          borderWidth: 1,
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "企业占比",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#FF0000",
            },
            data: [20, 50, 60, 70, 30, 20, 80],
          },
          {
            name: "就业人数占比",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#3FA4CC",
            },
            data: [20, 50, 60, 70, 30, 20, 80],
          },
        ],
      };
      echarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.info_cheart_ct {
  height: 600px;
  .el-card__body {
    height: 100%;
  }
}
</style>
